import { render, staticRenderFns } from "./RobberyHouseIsEmergencyServiceNeededQuestion.vue?vue&type=template&id=68b82246&scoped=true"
import script from "./RobberyHouseIsEmergencyServiceNeededQuestion.vue?vue&type=script&lang=ts"
export * from "./RobberyHouseIsEmergencyServiceNeededQuestion.vue?vue&type=script&lang=ts"
import style0 from "./RobberyHouseIsEmergencyServiceNeededQuestion.vue?vue&type=style&index=0&id=68b82246&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68b82246",
  null
  
)

export default component.exports